// extracted by mini-css-extract-plugin
module.exports = {"error":"#ff4040","success":"#28cb93","primary-color":"#00bfb2","dark-grey-color":"#444","container":"steps_container__14C_i","addButton":"steps_addButton__1yrlN"};